'use strict';

angular.module('lmsApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('files', {
                parent: 'course',
                url: '/:courseId/files/',
                data: {
                    roles: ['OP_MANAGE_COURSES']
                    // pageTitle: 'logs.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/files/files.html',
                        controller: 'FilesController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('files');
                        return $translate.refresh();
                    }]
                }
            });
    });
